const themeUtils = {
    utils: {
        flex: ({ ai = 'center', jc = 'center', dir = 'row' }) => {
            return `
        display: flex;
        justify-content: ${jc};
        align-items: ${ai};
        flex-direction: ${dir}
        `
        },
        toRgba: (hex: string, opacity = 1) => {
            hex = hex.slice(1, hex.length)

            if (hex.length !== 6) {
                throw new Error('Only six-digit hex colors are allowed.')
            }

            var aRgbHex = hex.match(/.{1,2}/g)!
            var aRgb = [parseInt(aRgbHex[0], 16), parseInt(aRgbHex[1], 16), parseInt(aRgbHex[2], 16)]
            return `rgba(${[...aRgb, opacity].join(',')})`
        },
    },
}

export default themeUtils
